<template>
    <div class="flex-col">
        <vnavbar title="器械清点" class="backbar" left-text="返回" left-arrow @click-left="back" />
        <div class="header">
            <div class="patient">
                <div class="name">{{surgeryInfo.patient_name}}</div>
                <div class="bed">{{surgeryInfo.sex||'--'}}/{{surgeryInfo.age||'--'}}/{{surgeryInfo.bed_no||'--'}}</div>
            </div>
            <div>
                <div class="more">
                    <div class="moredevice">{{surgeryInfo.surgeries}}</div>
                    <div @click="isShowMore=!isShowMore">查看更多<span><i
                                :class="isShowMore?'el-icon-arrow-up':'el-icon-arrow-down'"></i></span></div>
                </div>
                <div v-if="isShowMore" class="surgery">
                    <div>台次:{{surgeryInfo.scheduled_sequence}}</div>
                    <div>手术间:{{surgeryInfo.dic_operating_room}}</div>
                    <div>科室:{{surgeryInfo.dic_section}}</div>
                    <div>术前诊断:{{surgeryInfo.plan_diseases}}</div>
                    <div>手术医生:{{surgeryInfo.surgeon}}</div>
                    <div class="time">手术计划开始时间:{{surgeryInfo.plan_time && this.$moment(surgeryInfo.plan_time).format(`YYYY-MM-DD
                        HH:mm:ss`)}}</div>
                </div>
            </div>
        </div>
        <vcellgroup>
            <vrow>
                <vcol span="20">
                    <vfield v-model="nodeName" label="节点:" />
                </vcol>
                <vcol span="4" style="display: flex;align-items: center;justify-content: center;height: 100%;">
                    <vbutton style="
                        background: var(--primary-color, #009688);
                        font-size: 16px;
                        height: 40px;
                        padding: 0px 20px;
                        margin-right: 5px;
                        color: #ffffff;" type="info" @click="showSelectPackage">选择</vbutton>
                </vcol>
            </vrow>
            <vrow>
                <vcol span="20">
                    <vsearch placeholder="请输入条形码编号或包名称" v-model="searchValue" :show-action="showAction" @cancel="onCancel" @focus="onFocus"
                        @search="onSearch">
                        <div slot="action" @click="onSearch">
                            {{ searchValue ? '搜索' : '' }}
                        </div>
                    </vsearch>
                </vcol>
                <vcol span="4" @click="openScan"><span style="font-size: 18px;height:54px;line-height: 54px;">扫一扫</span></vcol>
            </vrow>
            <vfield v-model="internalcode" label="条码" />
            <vfield v-model="packageName" label="包名称" />
            <vfield v-model="validate1" label="有效期" />
        </vcellgroup>
                <div :style="{'height':`200px`}" style="overflow-y: scroll;">
                <vcellgroup v-for="(pkg, index) in allbatchpackages" :key="index">
                <template slot="title">
                    <div style="font-size: 22px;text-align: left;padding-left: 20px;" >{{pkg.package_name}}({{pkg.internal_code}})</div>
                </template>
                <vcell v-for="(item, idx) in pkg.dic_instrument_package.instruments" :key="idx">
                    <template slot="title">
                        <div style="text-align: left;padding-left: 20px;">{{item.name}}</div>
                    </template>
                    <vstepper slot="right-icon" v-model="item.quantity" button-size="24px" input-width="38px"
                        class="absolute right14" disabled />
                </vcell>
                </vcellgroup>
                </div>
        <!-- <vcellgroup>
            <template slot="title">
                <div style="font-size: 22px;text-align: left;padding-left: 20px;">总数量:{{sumtotal}}</div>
            </template>
                <vcellgroup v-for="(pkg, index) in allbatchpackages" :key="index">
                                <template slot="title">
                                    <div style="font-size: 22px;text-align: left;padding-left: 20px;" >{{pkg.package_name}}</div>
                                </template>
                <vcell v-for="(item, idx) in instruments" :key="idx">
                    <template slot="title">
                        <div style="text-align: left;padding-left: 20px;">{{item.instrument_name}}</div>
                    </template>
                    <vstepper slot="right-icon" v-model="item.amount[0]" button-size="24px" input-width="38px"
                        class="absolute right14" />
                </vcell>
                </vcellgroup>
            <vcell v-for="(item,index) in instruments" :key="index">
                <template slot="title">
                    <div style="text-align: left;padding-left: 20px;">{{item.name}}</div>
                </template>
                <vstepper slot="right-icon" v-model="item.quantity" button-size="24px" input-width="38px"
                    class="absolute right14" />
            </vcell>
        </vcellgroup> -->
            <!-- <div>总数量:{{sumtotal}}</div>

                <vlist v-model="loading" :finished="finished" finished-text="" @load="onLoad">
                    <div class="flex-row" v-for="(item,index) in instruments" :key="index">
                        <div>{{item.name}}</div>
                        <div>{{item.quantity}}</div>
                    </div>
                </vlist> -->

        <div class="bottom">
            <vbutton class="btnTrans" type="info" @click="back">确定</vbutton>
        </div>

        <vpopup v-model="showPackages" round position="bottom">
            <vsearch placeholder="请输入搜索关键词" v-model="searchpakValue" :show-action="showAction1" @cancel="onCancel1" @focus="onFocus1"
                        @search="onSearchPackage">
                <div slot="action" @click="onSearchPackage">
                    {{ searchpakValue ? '搜索' : '' }}
                </div>
            </vsearch>
            <vpicker show-toolbar :columns="packages" @confirm="selectPackage" @cancel="cancelPackage" />
        </vpopup>
    </div>
</template>

<script>
import { Picker as vpicker, Popup as vpopup, Row as vrow, Col as vcol, CellGroup as vcellgroup, Cell as vcell, Stepper as vstepper, PullRefresh as vpullrefresh, List as vlist, Empty as vempty, Search as vsearch, Field as vfield, Tab as vtab, Tabs as vtabs, NavBar as vnavbar, Empty, Button as vbutton, Dialog, Tabbar as vtabbar, TabbarItem as vtabbaritem, Icon as vicon, Tag as vtag } from 'vant'
import 'vant/lib/index.css'
import { mapGetters } from 'vuex'
export default {
    name: `CountInstrumentCreate`,
    components: { vpicker, vpopup, vrow, vcol, vcellgroup, vcell, vstepper, vpullrefresh, vlist, vempty, vsearch, vfield, vtab, vtabs, vnavbar, Empty, vtabbar, vtabbaritem, vbutton, [Dialog.Component.name]: Dialog.Component, vicon, vtag },
    data() {
        let paramsObj = null
        paramsObj = this.readSession()
        return {
            surgeryId: this.$route.query.surgeryId || (paramsObj.surgeryId && parseInt(paramsObj.surgeryId) || 0),
            surgeryInfo: this.$route.params.surgeryInfo || paramsObj.surgeryInfo,
            prevPath: this.$route.params.prevPath || paramsObj.prevPath,
            activeStage: this.$route.params.activeStage || paramsObj.activeStage,
            countStage: this.$route.params.countStage || paramsObj.countStage,
            stageId: this.$route.params.activeStage.id || paramsObj.stageId,
            package_style: this.$root.PackageCountingType, // separated  combin
            loading: false,
            finished: true,
            refreshing: false,
            searchValue: ``,
            scanActive: true,
            internalcode: ``,
            packageName: ``,
            validate1: ``,
            packagewardId: 0,
            sumtotal: 0,
            showAction: false,
            allbatchpackages: [
            ],
            nodeName: `术前添加`,
            showAction1: false,
            isShowMore: false,
            showPackages: false,
            internalcodes: [],
            searchpakValue: ``,
            packages: []
        }
    },
    computed: {
        ...mapGetters([`currentUser`, `sysuser/workers`, `screenHeight`, `operation_ward_auth`, `active_hospital_ward`, `userConfigs`]),
        filterScopeInfo() {
            let that = this
            let filterScope = _.filter(that.userConfigs, { key: `instrumentFilterScope` })
            if (filterScope && filterScope.length > 0) {
                return filterScope[0].value.trim()
            }
            return [2]
        }
    },
    created() {
        this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
            this.loadUsedPackage()
            this.loadInternalcodes()
        })
    },
    mounted() { },
    beforeRouteLeave(to, from, next) {
        let params = {
            surgeryId: this.surgeryId,
            surgeryInfo: this.surgeryInfo,
            prevPath: this.prevPath,
            activeStage: this.activeStage,
            countStage: this.countStage,
            stageId: this.stageId
        }
        sessionStorage.setItem(`params`, JSON.stringify(params))
        next()
    },
    methods: {
        loadInternalcodes() {
            let that = this
            if (!this.surgeryId) return
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/Nursing/CountingContent/Search?wardId=${that.surgeryInfo.dic_operating_ward_id}&surgeryId=${that.surgeryId}&filterScope=${this.filterScopeInfo}`)
                req.then(data => {
                    console.log(`codes`, data)
                    that.internalcodes = data && _.map(data, item => {
                        return { text: `【${item.group}】${item.label}`, value: item.value }
                    })
                    that.packages = _.cloneDeep(that.internalcodes)
                }).catch(e => {
                    that.internalcodes = []
                    that.packages = []
                })
            })
        },
        showSelectPackage() {
            this.showPackages = true
        },
        onSearchPackage() {
            let that = this
            if (that.searchpakValue) {
                that.packages = that.internalcodes.filter(item => item.text.toLowerCase().includes(that.searchpakValue.toLowerCase()))
            } else {
                that.packages = that.internalcodes
            }
        },
        selectPackage(value, index) {
            let that = this
            console.log(`选中的`, value)
            if (value) {
                that.searchValue = value && value.value
                that.onSearch()
                that.showPackages = false
            }
        },
        cancelPackage() {
            this.showPackages = false
        },
        onFocus1() {
            this.showAction1 = true
        },
        onCancel1() {
            this.showAction1 = false
        },
        readSession() {
            // 读取暂存的查询条件
            let sessionParamsObj = sessionStorage.getItem(`params`)
            let paramsObj = null
            if (sessionParamsObj && JSON.parse(sessionParamsObj) != null) {
                paramsObj = JSON.parse(sessionParamsObj)
            }
            return paramsObj
        },
        loadUsedPackage() {
            let req = this.myaxios.get(`/api/Nursing/CountingContent/GetUsedPackage?stageId=${this.stageId}`)
            req.then(usedpackage => {
                this.allbatchpackages = usedpackage || []
            }).catch(e => {
                console.log(e)
            })
        },
        onFocus() {
            this.showAction = true
        },
        onCancel() {
            this.showAction = false
        },
        onSearch() {
            let that = this
            this.internalcode = ``
            this.packageName = ``
            this.validate1 = ``
            this.packagewardId = 0
            this.sumtotal = 0
            if (this.searchValue) {
                let fiv = _.findIndex(that.allbatchpackages, function(i) {
                    return i.internal_code.toUpperCase() == that.searchValue.trim().toUpperCase()
                })
                let task = new Promise((resolve, reject) => {
                    if (fiv > -1) {
                        this.$confirm(`是否删除?`, `提示`, {
                            confirmButtonText: `确定`,
                            cancelButtonText: `取消`,
                            type: `warning`,
                            closeOnClickModal: false
                        })
                            .then(() => {
                                resolve()
                            })
                            .catch(e => {
                                reject()
                            })
                    } else {
                        resolve()
                    }
                })
                task.then(() => {
                    that.saveInfo(fiv)
                }).catch(e => { })
            }
        },
        saveInfo(fiv) {
            let that = this
            // 器械包绑定清点流程
            if (!this.surgeryInfo || !this.surgeryInfo.dic_operating_ward_id) {
                that.$message.error(`手术信息加载失败,请退出页面刷新后重试`)
                return
            }
            let req = that.myaxios.post(
                `/api/Nursing/CountingContent/${this.package_style == `separated` ? `ScanPackageSeparated` : `ScanPackage`}?code=${this.searchValue.trim()}&surgeryId=${this.surgeryId}&stageId=${this.stageId
                }&wardId=${this.surgeryInfo.dic_operating_ward_id}`
            )

            let now = that.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            let req2 = that.myaxios.post(`/api/Nursing/CountingFlow/UpdateStageTime?stageId=${that.stageId}&dateTime=${now}`)
            that.myaxios
                .all(req, req2).then(([data], t) => {
                    if (data && fiv == -1) {
                        that.allbatchpackages.push(data)
                        that.internalcode = data.internal_code
                        that.packageName = data.package_name
                        that.validate1 = data.valid_date && that.$moment(data.valid_date).format(`yyyy-MM-DD`)
                        that.packagewardId = data.dic_operating_ward_id
                    } else {
                        that.allbatchpackages.splice(fiv, 1)
                    }
                }).catch(e => {
                    console.log(e)
                })
        },
        back() {
            this.$router.push({ name: `CountInstrument`, query: { surgeryId: this.surgeryId }, params: { surgeryInfo: this.surgeryInfo, countStage: this.countStage, activeTabStageId: this.stageId, prevPath: this.prevPath } }).catch(err => err)
        },
        onLoad() {
        },
        onRefresh() {
        },
        setscanActive() {
            setTimeout(() => {
                this.scanActive = true
            }, 2000)
        },
        openScan() {
            let that = this
            this.scanActive = false
            this.setscanActive()
            // 存在cordova在打开
            // eslint-disable-next-line no-undef
            if (typeof cordova != `undefined`) {
                // eslint-disable-next-line no-undef
                if (!cordova.plugins.barcodeScanner) {
                    Dialog({ title: `提示信息`, message: `当前设备不支持扫码` })
                }
                // eslint-disable-next-line no-undef
                cordova.plugins.barcodeScanner.scan(
                    function(result) {
                        that.searchValue = result.text
                        that.onSearch()
                    },
                    function(error) {
                        Dialog({ title: `提示信息`, message: `扫码失败` + error })
                    },
                    {
                        preferFrontCamera: false, // iOS and Android
                        showFlipCameraButton: true, // iOS and Android
                        showTorchButton: true, // iOS and Android
                        torchOn: false, // Android, launch with the torch switched on (if available)
                        saveHistory: true, // Android, save scan history (default false)
                        prompt: `请扫描二维码`, // Android
                        resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
                        // formats : "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
                        orientation: `portrait`, // Android only (portrait|landscape), default unset so it rotates with the device
                        disableAnimations: true, // iOS
                        disableSuccessBeep: false // iOS and Android
                    }
                )
            } else {
                Dialog({ title: `提示信息`, message: `当前设备不支持扫码` })
            }
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            if (newUrl.path == `/t_countinstrumentcreate`) {
                this.surgeryId = this.$route.query.surgeryId
                this.surgeryInfo = this.$route.params.surgeryInfo
                this.loadUsedPackage()
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import '../mobile_common.css';
.backbar{
    background-color: #04A891;
    border:unset !important;
    /deep/ .van-icon{
        color:#ffffff !important;
    }
    /deep/ .van-nav-bar__text{
        color:#ffffff !important;
    }
    /deep/ .van-nav-bar__title{
        color:#ffffff !important;
    }
}
.van-hairline--bottom::after{
    border-bottom-width:0px !important;
}
.header {
    color:#ffffff !important;
    background: #04A891 !important;
    font-size: 14px;
    text-align: left;
    .patient {
        line-height: 23px;
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        height: 46px;
        .name{
            padding:0 20px;
            font-size: 17px;
        }
    }
    .surgery {
        border-top: 1px dashed #ffffff;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        flex-wrap: wrap;
        div {
            width: 50%;
            height:30px;
            line-height:30px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 16px;
            padding: 0 16px;
        }
        .time{
            flex-basis:100% !important;
        }
    }
    .more{
        align-items: center;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        justify-content: space-between;
        margin: 0 16px;
        padding-bottom: 10px;
        .moredevice{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 16px;
            max-width: 80%;
        }
        }
}
.bottom {
    display: flex;
    position: fixed;
    bottom: 0px;
    width:100%;
    .btnTrans {
        flex:1;
        background: var(--primary-color, #009688);
        margin: 5px;
        height: 40px;
        padding: 0px 30px;
        color: #ffffff;
    }
}
.line{
    margin:0px 24px;
    width:1px;
    height:130px;
    background:#EBEBEB;
}
.scrollContent{
    overflow-y: auto;
    overflow-x: hidden;
}
.content{
    display:flex;
    font-size:20px;
    .panel{
        position: relative;
        width: 100%;
        padding: 0 16px;
        text-align: left;
        .monthday{
            position: absolute;
            left:-40px;
            top:0px;
            opacity: 1;
            background: #fff;
            font-size:18px;
        }
        .date{
            position: absolute;
            left:-40px;
            top:8px;
            opacity: 1;
            background: #fff;
            font-size:18px;
        }
        .step{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: start;
            font-size: 16px;
            color: rgba(102, 102, 102, 1);
        }
        .steprowone{
            flex-basis: 70%;
            font-weight: 500;
            font-size: 20px;
            color: var(--primary-color, #009688);
            line-height: 36px;
            height: 36px;
            text-align: left;
            font-style: normal;
            overflow-wrap: break-word;
            white-space: nowrap;
            margin-top: 1px;
        }
        .phone{
            background-color: #E0F2EE;
            border-radius: 50%;
            height: 24px;
            width: 24px;
            line-height: 24px;
            text-align: center;
        }
        .steprowtwo{
            flex-basis: 100%;
            margin-top: 5px;
        }
        .remark{
            flex-basis: 90%;
            padding: 5px 10px 10px 0px;
            background-color: rgba(245, 245, 245, 1);
            border-radius: 2px;
        }
    }
    }
</style>



// WEBPACK FOOTER //
// src/components/Mobile/Transfer/CountInstrumentCreate.vue